module.exports = __webpack_public_path__ + "img/woodwork.3bdfb983.svg";